import { render, staticRenderFns } from "./zipread.vue?vue&type=template&id=7be5e628&scoped=true&"
import script from "./zipread.vue?vue&type=script&lang=js&"
export * from "./zipread.vue?vue&type=script&lang=js&"
import style0 from "./zipread.vue?vue&type=style&index=0&id=7be5e628&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be5e628",
  null
  
)

export default component.exports